import { customAxios } from '../../common/customAxios';

interface IPostDictionaryMachineReportsParams {
  machineId: string;
  reqBody: {
    detail: string;
  };
}

export const postDictionaryMachineReports = ({
  machineId,
  reqBody,
}: IPostDictionaryMachineReportsParams): Promise<void> => {
  return customAxios.post(`/dictionary/machines/${machineId}/reports`, reqBody);
};
